<template>
  <div class="py-1 px-2 rounded border" v-bind:style="{ backgroundColor: color }">
    <span>{{ params.value }}</span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: null,
      color: null,
    };
  },
  beforeMount() {
    this.color = this.params.color || 'white';
  },
};
</script>
